/* eslint-disable no-unused-vars */
import { ToastContainer, toast } from "react-toastify";

function errorTost(message) {
  toast.dismiss();
  toast.error(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}

function successTost(message) {
  toast.dismiss();
  toast.success(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}

function infoTost(message) {
  toast.dismiss();
  toast.info(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}
function onlineToast(message) {
  toast.dismiss();
  toast.info(message ? message : 'Back online!', {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}
function offlineToast(message) {
  toast.dismiss();
  toast.info(message ? message : "You're offline. Please check your internet connection!", {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}
export { errorTost, successTost, infoTost, onlineToast, offlineToast };
